import mixpanel from 'mixpanel-browser'
import mixpanelHelper from '~/utils/mixpanel'

function installGATracker(token) {
  if (document.getElementById('bb-ga-tracker')) {
    window.ga = window.__ga

    return window.ga
  } else {
    delete window.ga
    ;(function (i, s, o, g, r, a, m) {
      // eslint-disable-next-line
      i['GoogleAnalyticsObject'] = r
      // eslint-disable-next-line
      ;(i[r] =
        i[r] ||
        function () {
          ;(i[r].q = i[r].q || []).push(arguments)
        })((i[r].l = 1 * new Date()))
      // eslint-disable-next-line
      ;(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
      a.async = 1
      a.src = g
      a.id = 'bb-ga-tracker'
      m.parentNode.insertBefore(a, m)
    })(
      window,
      document,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga'
    )

    const ga = window.ga
    ga('create', token, {
      cookieExpires: 31536000, // 12 months, in seconds
    })
    ga('set', 'anonymizeIp', true)

    return ga
  }
}

function removeGATracker() {
  if (document && document.getElementById('bb-ga-tracker')) {
    document.getElementById('bb-ga-tracker').outerHTML = ''
  }
}

function installMPTracker(token) {
  const mpOptions = {}
  mixpanelHelper.configure(mixpanel)
  mixpanelHelper.client.init(token, mpOptions)

  return mixpanelHelper
}

const noop = (_) => _

export default (context, inject) => {
  const { app } = context

  const { optEnableMetricsTrackers } = context.store.state.root

  const gaToken = app.$voicer.getConfig('analytics.ga')
  const mpToken = app.$voicer.getConfig('analytics.mixpanel')

  class Tracking {
    // pseudo priv
    _gaActive = optEnableMetricsTrackers && !!gaToken
    _mpActive = optEnableMetricsTrackers && !!mpToken
    _sentryActive = optEnableMetricsTrackers

    // pseudo pub
    disabled = optEnableMetricsTrackers === false

    constructor() {
      // ga part
      if (this.gaActive) {
        this.ga = installGATracker(gaToken)
      } else {
        // tricky
        window.__ga = window.ga
        window.ga = noop
      }

      // mixpanel part
      if (this.mpActive) {
        this.mp = installMPTracker(mpToken)
      }

      app.router.afterEach((to, from) => {
        mixpanelHelper.visit({ from: from.fullPath, to: to.fullPath })
      })
    }

    get gaActive() {
      return this._gaActive
    }

    set gaActive(status) {
      if (status === false) {
        // disable GA
        window[`ga-disable-${gaToken}`] = true
        window.__ga = window.ga
        window.ga = noop
        removeGATracker()
      } else {
        // enable GA
        window[`ga-disable-${gaToken}`] = false
        installGATracker(gaToken)
      }
    }

    get mpActive() {
      return this._mpActive
    }

    set mpActive(status) {
      if (status === false) {
        // disable MP
        if (mixpanelHelper.isConfigured) {
          mixpanelHelper.client.opt_out_tracking()
        }
      } else {
        // enable MP
        if (mixpanelHelper.isConfigured === false) {
          installMPTracker(mpToken)
        }
        setTimeout(() => {
          mixpanelHelper.client.opt_in_tracking()
        }, 0)
      }
    }

    get sentryActive() {
      return this._sentryActive
    }

    set sentryActive(status) {
      const hub = app.$sentry.getCurrentHub()

      if (!hub) {
        this._sentryActive = false
        return
      }

      if (status === false) {
        // disable Sentry
        hub.getClient().getOptions().enabled = false
      } else {
        // enable Sentry
        hub.getClient().getOptions().enabled = true
      }
    }

    identifyUser() {
      if (app.$spoke.site.optAuthentication === false) {
        mixpanelHelper.identify(
          app.$spoke.user.session.id,
          app.$spoke.user.session.toJSON()
        )
      } else {
        mixpanelHelper.identify(app.$spoke.user.id, app.$spoke.user.toJSON())
      }
    }

    captureException(exception) {
      mixpanelHelper.exception(exception)
    }

    disableMetricTrackers() {
      if (this.disabled === false) {
        this.disabled = true
        this.gaActive = false
        this.mpActive = false
        this.sentryActive = false
        app.$spoke.eventManager.emit('disable_metrics_trackers', {
          ga: false,
          mp: false,
          sentry: false,
        })
      }
    }

    enableMetricTrackers() {
      if (this.disabled === true) {
        this.disabled = false
        this.gaActive = true
        this.mpActive = true
        this.sentryActive = true
        app.$spoke.eventManager.emit('enable_metrics_trackers', {
          ga: true,
          mp: true,
          sentry: true,
        })
      }
    }
  }

  inject('tracking', new Tracking())
}
